import RecurrenceWeekly from './RecurrenceWeekly';

export default RecurrenceWeekly;
